import { type FunctionComponent, type PropsWithChildren, type RefObject } from 'react';
import cn from 'classnames';
import { type StatusWrapperProps } from '../../../StatusWrapper';
import styles from './GridLayoutWrapper.module.css';

export interface GridLayoutWrapperProps extends StatusWrapperProps {
    contentRef?: RefObject<HTMLDivElement>;
    contentClassName?: string;
}

export const GridLayoutWrapper: FunctionComponent<PropsWithChildren<GridLayoutWrapperProps>> = ({
    contentRef,
    children,
    contentClassName,
}) => (
    <div ref={contentRef} className={cn(styles.content, contentClassName)}>
        {children}
    </div>
);
